var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_1346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9082 9.248L9.6082 14.9133M17.0842 22.392L22.7522 24.092",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5771 16.4227L23.2558 8.744",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 7.33333C5.3335 7.59597 5.38523 7.85604 5.48574 8.0987C5.58625 8.34135 5.73357 8.56182 5.91928 8.74754C6.105 8.93326 6.32548 9.08058 6.56813 9.18109C6.81078 9.2816 7.07085 9.33333 7.3335 9.33333C7.59614 9.33333 7.85621 9.2816 8.09886 9.18109C8.34151 9.08058 8.56199 8.93326 8.74771 8.74754C8.93343 8.56182 9.08075 8.34135 9.18126 8.0987C9.28176 7.85604 9.3335 7.59597 9.3335 7.33333C9.3335 7.07068 9.28176 6.81061 9.18126 6.56796C9.08075 6.32531 8.93343 6.10483 8.74771 5.91911C8.56199 5.7334 8.34151 5.58608 8.09886 5.48557C7.85621 5.38506 7.59614 5.33333 7.3335 5.33333C7.07085 5.33333 6.81078 5.38506 6.56813 5.48557C6.32548 5.58608 6.105 5.7334 5.91928 5.91911C5.73357 6.10483 5.58625 6.32531 5.48574 6.56796C5.38523 6.81061 5.3335 7.07068 5.3335 7.33333Z",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 7.33333C22.6665 7.86376 22.8772 8.37247 23.2523 8.74754C23.6274 9.12261 24.1361 9.33333 24.6665 9.33333C25.1969 9.33333 25.7056 9.12261 26.0807 8.74754C26.4558 8.37247 26.6665 7.86376 26.6665 7.33333C26.6665 6.8029 26.4558 6.29419 26.0807 5.91911C25.7056 5.54404 25.1969 5.33333 24.6665 5.33333C24.1361 5.33333 23.6274 5.54404 23.2523 5.91911C22.8772 6.29419 22.6665 6.8029 22.6665 7.33333Z",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 24.6667C22.6665 25.1971 22.8772 25.7058 23.2523 26.0809C23.6274 26.456 24.1361 26.6667 24.6665 26.6667C25.1969 26.6667 25.7056 26.456 26.0807 26.0809C26.4558 25.7058 26.6665 25.1971 26.6665 24.6667C26.6665 24.1362 26.4558 23.6275 26.0807 23.2525C25.7056 22.8774 25.1969 22.6667 24.6665 22.6667C24.1361 22.6667 23.6274 22.8774 23.2523 23.2525C22.8772 23.6275 22.6665 24.1362 22.6665 24.6667Z",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 20.6667C5.3335 22.258 5.96564 23.7841 7.09086 24.9093C8.21607 26.0345 9.7422 26.6667 11.3335 26.6667C12.9248 26.6667 14.4509 26.0345 15.5761 24.9093C16.7014 23.7841 17.3335 22.258 17.3335 20.6667C17.3335 19.0754 16.7014 17.5492 15.5761 16.424C14.4509 15.2988 12.9248 14.6667 11.3335 14.6667C9.7422 14.6667 8.21607 15.2988 7.09086 16.424C5.96564 17.5492 5.3335 19.0754 5.3335 20.6667Z",
    stroke: "#873CAA",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_1346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgBoard);
export default __webpack_public_path__ + "static/media/org-board.a27da6529da2594ee6313335793105ff.svg";
export { ForwardRef as ReactComponent };